<template>
  <!-- pricing Section -->
  <section class="pricing-sections">
    <div class="price-bg d-none d-md-block">
      <img src="@/assets/img/bg/dot-blue.png" class="img-fluid" alt="bg" />
    </div>
    <div class="container">
      <div class="section-heading">
        <div class="row">
          <div class="col-md-12 text-center aos" data-aos="fade-up">
            <h2>Pricing Plans</h2>
            <p>
              Designed to effectively communicate your service offerings and their
              associated costs
            </p>
          </div>
        </div>
      </div>
      <div class="row aos" data-aos="fade-up">
        <div class="col-lg-4 col-sm-12 d-flex">
          <div class="pricing-plans card flex-fill">
            <div class="card-header">
              <div class="mb-3">
                <div class="pricing-header mb-3 text-center">
                  <h4>Basic</h4>
                  <p class="fs-14">Basic service description and up to 3 images</p>
                </div>
                <div class="pricing-header-dollar text-center">
                  <h3>$50 <span class="fs-14 text-gray">/month</span></h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="body-content mt-3">
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Ability to list up to 3 services</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Access to buyer inquiries</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Basic customer support</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-light-500 me-2"></span>
                  <p class="text-dark fs-14">5% transaction fee on sales</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-light-500 me-2"></span>
                  <p class="text-dark fs-14">
                    New service providers can test the platform.
                  </p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-light-500 me-2"></span>
                  <p class="text-dark fs-14">
                    Custom pricing for enterprise-level service
                  </p>
                </div>
              </div>
            </div>
            <div class="card-footer border-0">
              <div class="pricing-btn d-flex">
                <a
                  href="#"
                  class="btn btn-dark d-flex align-items-center justify-content-center w-100"
                  >Get Started <i class="ti ti-circle-arrow-right ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-12 d-flex">
          <div class="pricing-plans card active position-relative flex-fill">
            <span class="position-absolute popular-badge"> Popular </span>
            <div class="card-header">
              <div class="mb-3">
                <div class="pricing-header mb-3 text-center">
                  <h4>Standard</h4>
                  <p class="fs-14">Enhanced service description with video support</p>
                </div>
                <div class="pricing-header-dollar text-center">
                  <h3>$100 <span class="fs-14 text-gray">/month</span></h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="body-content mt-3">
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Ability to list up to 3 services</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Access to buyer inquiries</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Basic customer support</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">3% transaction fee on sales</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">
                    New service providers can test the platform.
                  </p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-light-500 me-2"></span>
                  <p class="text-dark fs-14">
                    Custom pricing for enterprise-level service
                  </p>
                </div>
              </div>
            </div>
            <div class="card-footer border-0">
              <div class="pricing-btn d-flex">
                <a
                  href="#"
                  class="btn btn-dark d-flex align-items-center justify-content-center w-100"
                  >Get Started <i class="ti ti-circle-arrow-right ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-12 d-flex">
          <div class="pricing-plans card flex-fill">
            <div class="card-header">
              <div class="mb-3">
                <div class="pricing-header mb-3 text-center">
                  <h4>Premium</h4>
                  <p class="fs-14">Advanced service with multiple media types</p>
                </div>
                <div class="pricing-header-dollar text-center">
                  <h3>$150 <span class="fs-14 text-gray">/month</span></h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="body-content mt-3">
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Unlimited service listings</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Unlimited images per service</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Access to advanced marketing tools </p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">2% transaction fee on sales</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Dedicated account manager</p>
                </div>
                <div class="d-flex align-items-center content-list">
                  <span class="ti ti-circle-check-filled text-success me-2"></span>
                  <p class="text-dark fs-14">Analytics dashboard to track performance</p>
                </div>
              </div>
            </div>
            <div class="card-footer border-0">
              <div class="pricing-btn d-flex">
                <a
                  href="#"
                  class="btn btn-dark d-flex align-items-center justify-content-center w-100"
                  >Get Started <i class="ti ti-circle-arrow-right ms-2"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /pricing Section -->

  <!-- Client Section -->
  <section class="client-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading aos" data-aos="fade-up">
            <h2>What our client says</h2>
            <p>
              Description highlights the value of client feedback, showcases real
              testimonials, and encourages potential clients to engage with your company.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel testimonial-slider pt-5">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexplaning" :key="item.id">
                <div class="client-widget card aos" data-aos="fade-up">
                  <div class="card-body">
                    <div class="client-img">
                      <a href="#">
                        <img
                          class="img-fluid"
                          alt="Image"
                          :src="require(`@/assets/img/profiles/${item.Image}`)"
                        />
                      </a>
                    </div>
                    <div class="client-content">
                      <div class="rating">
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                        <i class="fas fa-star filled me-1"></i>
                      </div>
                      <p>{{ item.Content }}</p>
                      <h5>{{ item.Name }}</h5>
                      <h6>{{ item.Position }}</h6>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Client Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexplaning from "@/assets/json/indexplanning.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexplaning: indexplaning,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
